export default "__VITE_ASSET__0d30d4ce__"